import { Component, type ErrorInfo, type ReactNode } from 'react';
import i18n from 'i18next';

/** Si una pantalla falla al dibujarse, un aviso con un botón para recargar.
 *
 *  Sin esto, cualquier error al dibujar desmonta la aplicación entera y el
 *  socio ve una página en blanco, sin saber qué pasó ni qué hacer — que es
 *  lo que vieron los socios con el traductor del navegador (octubre de
 *  2026). Está fuera del enrutador y del idioma de React a propósito: tiene
 *  que poder dibujarse aunque lo que haya fallado sea justo eso. */
export class Fallo extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('ETC Connect: la pantalla falló al dibujarse', error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    const t = (k: string) => i18n.t(`fallo.${k}`);
    return (
      <div
        translate="no"
        role="alert"
        style={{
          minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
          padding: 24, fontFamily: "'Nunito Variable', 'Nunito', sans-serif", color: '#2A3441',
        }}
      >
        <div style={{ maxWidth: 520, textAlign: 'center' }}>
          <h1 style={{ fontSize: 22, margin: '0 0 12px' }}>{t('titulo')}</h1>
          <p style={{ margin: '0 0 10px', lineHeight: 1.5 }}>{t('texto')}</p>
          <p style={{ margin: '0 0 22px', lineHeight: 1.5, color: '#5B6675', fontSize: 14 }}>{t('traductor')}</p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              background: '#F26522', color: '#fff', border: 'none', borderRadius: 6,
              padding: '10px 18px', fontSize: 15, fontWeight: 700, cursor: 'pointer',
            }}
          >
            {t('recargar')}
          </button>
        </div>
      </div>
    );
  }
}
